module.exports = __webpack_public_path__ + "img/insights.0410fabc.svg";